import React, { useEffect, useState, useContext } from "react";
import { Link, useParams } from "react-router-dom";
import Product from "../../Components/Shared/Product";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCaretRight,
  faList,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { ThreeDots } from "react-loader-spinner";
import { Helmet } from "react-helmet-async";
import { ThemeContext } from "../../Contexts/ThemeContext";
import { toast } from "react-hot-toast";
import { addToDb } from "../../utilities/CartDb";
import "./CategoryPage.css";

const CategoryPage = () => {
  const [categoryProducts, setCategoryProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const { category } = useParams();
  const [list, setList] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [page, setPage] = useState(0);
  const [isOpen, setIsOpen] = useState(true);
  const [isOpen1, setIsOpen1] = useState(false);
  const [isOpen2, setIsOpen2] = useState(false);
  const [from, setFrom] = useState(0);
  const [to, setTo] = useState(1000);
  const [sortBy, setSortBY] = useState("Recommanded");
  const [categories, setCategories] = useState([]);

  // BOGO OFFER CONTROL - SET TO false TO DISABLE INSTANTLY
  const enableBogoOffer = true;

  // BOGO Modal States
  const [showBogoModal, setShowBogoModal] = useState(false);
  const [bogoBoughtProduct, setBogoBoughtProduct] = useState(null);
  const [selectedFreeProduct, setSelectedFreeProduct] = useState(null);

  // Access cart from context
  const { cart, setCart } = useContext(ThemeContext);

  const isBogoCategory =
    enableBogoOffer &&
    ["hair color", "shampoo"].includes(category?.toLowerCase());

  useEffect(() => {
    fetch(
      `https://clariss-backend-one.vercel.app/categoryProductCount?name=${category}`,
    )
      .then((res) => res.json())
      .then((data) => {
        const count = data.count;
        const pages = Math.ceil(count / 50);
        setPageCount(pages);
      });

    fetch(`https://clariss-backend-one.vercel.app/categories`)
      .then((res) => res.json())
      .then((data) => {
        setCategories(data);
      });
  }, [category]);

  useEffect(() => {
    setCategoryProducts([]);
    setLoading(true);
    fetch(
      `https://clariss-backend-one.vercel.app/getProductsByCategories?name=${category}&page=${page}`,
    )
      .then((res) => res.json())
      .then((data) => {
        setCategoryProducts(data);
        setLoading(false);
      });
    window.scrollTo(0, 0);
  }, [category, page]);

  useEffect(() => {
    const sorted = [...categoryProducts];
    sorted.sort((a, b) => {
      if (a.stock_quantity > 0 && b.stock_quantity < 1) return -1;
      if (a.stock_quantity < 1 && b.stock_quantity > 0) return 1;
      return 0;
    });

    if (sortBy === "Price: Low to High") {
      setFilteredProducts(sorted.sort((a, b) => a.price - b.price));
    } else if (sortBy === "Price: High to Low") {
      setFilteredProducts(sorted.sort((a, b) => b.price - a.price));
    } else {
      setFilteredProducts([]);
    }
  }, [sortBy, categoryProducts]);

  // Listen for Add to Cart from Product component
  useEffect(() => {
    const handleAddToCart = (e) => {
      const { product } = e.detail;
      // if (isBogoCategory && product.stock_quantity > 0) {
      //   setBogoBoughtProduct(product);
      //   setShowBogoModal(true);
      // }
    };
    window.addEventListener("addToCartTrigger", handleAddToCart);
    return () =>
      window.removeEventListener("addToCartTrigger", handleAddToCart);
  }, [isBogoCategory]);

  const handleFilter = () => {
    const filtered = categoryProducts.filter(
      (product) => product.regular_price >= from && product.regular_price <= to,
    );
    setFilteredProducts(filtered);
  };

  const handleReset = () => {
    setFilteredProducts([]);
    setFrom(0);
    setTo(1000);
  };

  const meta_description = categories.find(
    (item) => item?.name?.toLowerCase() === category?.toLowerCase(),
  )?.meta_description;

  // Add Free BOGO Gift (same logic as Product.js)
  const addFreeBogoGift = () => {
    if (!selectedFreeProduct) return;

    const freeProduct = {
      ...selectedFreeProduct,
      price: 0,
      regular_price: 0,
      sale_price: 0,
      isFreeBogoGift: true,
      quantity: 1,
    };

    let newCart = [...cart];
    const exists = newCart.find((p) => p._id === freeProduct._id);

    if (!exists) {
      newCart.push(freeProduct);
    } else {
      exists.quantity += 1;
    }

    setCart(newCart);
    addToDb(freeProduct._id);
    toast.success(`${freeProduct.name} added as your FREE gift!`);

    setShowBogoModal(false);
    setSelectedFreeProduct(null);
    setBogoBoughtProduct(null);
  };

  return (
    <div
      className={`w-[95%]  bg-white mx-auto mb-20 ${window.innerWidth >= 1920 ? "2xl:w-[65%]" : "2xl:w-[80%]"}`}
    >
      <Helmet>
        <title>{category?.toUpperCase()} - Clariss Bangladesh</title>
        <meta name="description" content={meta_description} />
        <link
          rel="canonical"
          href={`https://clariss.com.bd/product-category/${category}`}
        />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "http://schema.org",
            "@type": "ItemList",
            name: category?.toUpperCase(),
            itemListElement: categoryProducts.map((p, i) => ({
              "@type": "ListItem",
              position: i + 1,
              url: `https://clariss.com.bd/product/${p?.slug}`,
            })),
          })}
        </script>
      </Helmet>

      <div className=" mt-5 w-[90%] 2xl:w-full lg:w-full mx-auto ">
        <p className="text-[14px] font-semibold">
          Home
          <FontAwesomeIcon className="mx-2" icon={faCaretRight} />
          {category?.toUpperCase()}
        </p>
      </div>


      <div className="flex justify-between mt-3  mb-3">
        <h1
          className={`w-[90%] 2xl:w-full lg:w-full mx-auto  ${category?.includes("top 10") ? "text-center" : ""} font-bold  text-[22px]`}
        >
          {category?.toUpperCase()}
        </h1>

        <div className="hidden lg:flex items-center  ">
          <button onClick={() => setList(false)}>
            <img
              width="25"
              height="25"
              src="https://img.icons8.com/sf-regular-filled/48/grid.png"
              alt="grid"
              className="inline mt-[-4px]"
            />
            Grid
          </button>
          <button onClick={() => setList(true)} className="ml-8">
            <FontAwesomeIcon className="mx-2" icon={faList} /> List
          </button>
        </div>
      </div>



      {/* BOGO MODAL */}
      {showBogoModal && isBogoCategory && (
        <div className="fixed inset-0 bg-black bg-opacity-70 z-[9999] flex items-center justify-center pt-0 p-4">
          <div className="bg-white rounded-2xl shadow-2xl max-w-5xl w-full max-h-[90vh] overflow-y-auto">
            <div className="bg-gradient-to-r from-[#106836] to-[#1a8c52] text-white p-8 rounded-t-2xl relative">
              {/* <button
                onClick={() => {
                  setShowBogoModal(false);
                  setSelectedFreeProduct(null);
                }}
                className="absolute top-6 right-8 text-3xl hover:opacity-80"
              >
                <FontAwesomeIcon icon={faTimes} />
              </button> */}
              <h2 className="text-4xl font-bold text-center">
                Buy 1 Get 1 FREE!
              </h2>
              <p className="text-center mt-4 text-lg">
                You added: <strong>{bogoBoughtProduct?.name}</strong>
              </p>
              <p className="text-center mt-2 opacity-90 text-lg">
                Choose your FREE gift from below
              </p>
            </div>

            <div className="p-8">
              <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-8">
                {categoryProducts
                  .filter(
                    (p) =>
                      p.stock_quantity > 0 && p._id !== bogoBoughtProduct?._id,
                  )
                  .map((product) => (
                    <div
                      key={product._id}
                      onClick={() => setSelectedFreeProduct(product)}
                      className={`border-2 rounded-xl overflow-hidden cursor-pointer transition-all duration-300
                        ${
                          selectedFreeProduct?._id === product._id
                            ? "border-[#106836] ring-4 ring-[#106836]/30 shadow-2xl scale-105"
                            : "border-gray-300 hover:border-[#106836] hover:shadow-xl"
                        }`}
                    >
                      <img
                        src={product.images?.[0]?.src || product.images?.[0]}
                        alt={product.name}
                        className="w-full h-60 object-cover"
                      />
                      <div className="p-4 text-center bg-gray-50">
                        <p className="font-bold text-sm line-clamp-2">
                          {product.name}
                        </p>
                        <p className="text-green-600 font-bold mt-2">
                          FREE GIFT
                        </p>
                        {selectedFreeProduct?._id === product._id && (
                          <p className="text-[#106836] font-bold mt-3 text-lg">
                            Selected
                          </p>
                        )}
                      </div>
                    </div>
                  ))}
              </div>
            </div>

            <div className="p-8 bg-gray-50 border-t flex gap-6 justify-center">
              <button
                onClick={addFreeBogoGift}
                disabled={!selectedFreeProduct}
                className={`px-12 py-4 rounded-xl font-bold text-white text-lg transition ${
                  selectedFreeProduct
                    ? "bg-[#106836] hover:bg-[#0e5a2d] shadow-lg"
                    : "bg-gray-400 cursor-not-allowed"
                }`}
              >
                Add Free Gift & Continue
              </button>
            </div>
          </div>
        </div>
      )}

      {list ? (
        <div className="list-container grid gap-6 grid-cols-1">
          {categoryProducts?.map((product) => (
            <Product key={product._id} list={list} product={product} />
          ))}
        </div>
      ) : (
        <div className="flex flex-col lg:flex-row gap-10 borrder border-red-400">
          <div className="hidden lg:block lg:w-[25%]  rounded-3xl p-6 pl-0 shadow-lg shadow-[#ccccc]">
            <p className="mb-2 font-bold">SORT BY :</p>
            <div className="sticky top-[250px]">
              <select
                onChange={(e) => setSortBY(e.target.value)}
                className="px-4 py-2 rounded-lg font-bold w-full"
              >
                <option>Recommanded</option>
                <option>New Launches</option>
                <option>Price: High to Low</option>
                <option>Price: Low to High</option>
              </select>
            </div>
            <div className="w-[100%] mt-6 py-6 px-4 bg-primary rounded-lg sticky top-[300px]">
              <div className="bg-[#cccccc] h-[1px]"></div>
              <div className="flex justify-between items-center">
                <p className="text-sm my-2 font-bold">SHOP BY PRODUCT TYPE</p>
                <button
                  onClick={() => setIsOpen(!isOpen)}
                  className="font-bold text-2xl"
                >
                  {isOpen ? "-" : "+"}
                </button>
              </div>
              <div className="bg-[#cccccc] h-[1px]"></div>
              <div
                className={`flex flex-col overflow-hidden ease-in-out duration-200 mt-4 ${isOpen ? "h-fit-content" : "h-0"}`}
              >
                <Link
                  className="hover:text-accent ease-in-out duration-200"
                  to="/product-category/face wash"
                >
                  Face Wash
                </Link>
                <Link
                  className="hover:text-accent ease-in-out duration-200"
                  to="/product-category/lotion"
                >
                  Lotion
                </Link>
                <Link
                  className="hover:text-accent ease-in-out duration-200"
                  to="/product-category/fragrances"
                >
                  Fragrances
                </Link>
                <Link
                  className="hover:text-accent ease-in-out duration-200"
                  to="/product-category/baby care"
                >
                  Baby Care
                </Link>
                <Link
                  className="hover:text-accent ease-in-out duration-200"
                  to="/product-category/food-oil"
                >
                  Food Oil
                </Link>
                <Link
                  className="hover:text-accent ease-in-out duration-200"
                  to="/product-category/canned food"
                >
                  Canned Food
                </Link>
                <Link
                  className="hover:text-accent ease-in-out duration-200 mb-4"
                  to="/product-category/honey"
                >
                  Honey
                </Link>
                <div className="bg-[#cccccc] h-[1px]"></div>
              </div>
              <div className="flex justify-between items-center">
                <p className="text-sm my-2 font-bold">SHOP BY CONCERN</p>
                <button
                  onClick={() => setIsOpen1(!isOpen1)}
                  className="font-bold text-2xl"
                >
                  {isOpen1 ? "-" : "+"}
                </button>
              </div>
              <div className="bg-[#cccccc] h-[1px]"></div>
              <div
                className={` flex flex-col overflow-hidden ease-in-out duration-200 mt-4 ${isOpen1 ? "h-fit-content" : "h-0"}`}
              >
                <Link
                  className="hover:text-accent ease-in-out duration-200"
                  to="/product-category/personal care"
                >
                  Personal Care
                </Link>
                <Link
                  className="hover:text-accent ease-in-out duration-200 mb-4"
                  to="/product-category/food care"
                >
                  Food Care
                </Link>
                <div className="bg-[#cccccc] h-[1px]"></div>
              </div>
              <div className="flex justify-between items-center">
                <p className="text-sm my-2 font-bold">PRICE</p>
                <button
                  onClick={() => setIsOpen2(!isOpen2)}
                  className="font-bold text-2xl"
                >
                  {isOpen2 ? "-" : "+"}
                </button>
              </div>
              <div className="bg-[#cccccc] h-[1px]"></div>
              <div
                className={`flex flex-col overflow-hidden ease-in-out duration-200 mt-4 ${isOpen2 ? "h-fit-content" : "h-0"}`}
              >
                <input
                  onChange={(e) => setFrom(e.target.value)}
                  placeholder="From"
                  type="number"
                />
                <input
                  onChange={(e) => setTo(e.target.value)}
                  placeholder="To"
                  type="number"
                />
                <button
                  onClick={handleFilter}
                  className="bg-accent text-primary font-bold px-4 py-1 rounded-lg hover:bg-secondary ease-in-out duration-200 mt-2"
                >
                  Filter
                </button>
                {filteredProducts.length > 0 && (
                  <button
                    onClick={handleReset}
                    className="text-center mx-auto mt-4 text-[#ff0000] hover:underline"
                  >
                    Reset
                  </button>
                )}
              </div>
            </div>
          </div>

          <div className="">
            {category === "food care" ? (
              <img
                // src="https://luvit.com.bd/wp-content/uploads/2022/11/Clariss-web-slider-For-desktop.jpg"
                alt=""
                className="mb-10 rounded-xl shadow-lg"
              />
            ) : category === "personal care" ? (
              <img
                src="https://luvit.com.bd/wp-content/uploads/2022/11/Clariss-web-slider-For-desktop.jpg"
                alt=""
                className="mb-10 rounded-xl shadow-lg"
              />
            ) : category === "face wash" ? (
              <img
                // src="https://clariss.com.bd/static/media/Face%20wash.7e1f16119a8a3b6e8631.png"
                alt=""
                className="mb-10 rounded-xl shadow-lg"
              />
            ) : category === "fragrances" ? (
              <img
                // src="https://luvit.com.bd/wp-content/uploads/2024/03/clariss-Perfume-slider-desktop.6210c8c092609332a5d7.png"
                alt=""
                className="mb-10 rounded-xl shadow-lg mx-auto"
              />
            ) : category === "food-oil" ? (
              <img
                // src="https://luvit.com.bd/wp-content/uploads/2022/11/Clariss-web-slider-For-desktop.jpg"
                alt=""
                className="mb-10 rounded-xl shadow-lg mx-auto"
              />
            ) : category === "canned food" ? (
              <img
                // src="https://luvit.com.bd/wp-content/uploads/2022/11/Clariss-web-slider-For-desktop.jpg"
                alt=""
                className="mb-10 rounded-xl shadow-lg mx-auto"
              />
            ) : category === "honey" ? (
              <img
                // src="https://i.ibb.co.com/qrJ3M6v/Untitled-design.png"
                src="https://luvit.com.bd/wp-content/uploads/2026/02/banner-hunny-1-scaled.jpg"
                alt=""
                className="mb-10 rounded-xl mx-auto"
              />
            ) : category === "baby care" ? (
              <img
                // src="https://luvit.com.bd/wp-content/uploads/2022/11/Clariss-web-slider-For-desktop.jpg"
                alt=""
                className="mb-10 rounded-xl shadow-lg"
              />
            ) : (
              ""
            )}

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-8  lg:gap-6 md:grid-cols-3 xl:grid-cols-4 lg:w-[100%]">
              {loading ? (
                <div className="flex justify-center items-center h-[50vh] w-[100vw] lg:w-[55vw]">
                  <ThreeDots
                    height="100"
                    width="100"
                    radius="10"
                    color="#106836"
                    ariaLabel="three-dots-loading"
                    visible={true}
                  />
                </div>
              ) : (
                (filteredProducts.length > 0
                  ? filteredProducts
                  : categoryProducts
                )?.map((product) => (
                  <Product key={product._id} product={product} />
                ))
              )}
            </div>
          </div>
        </div>
      )}

      {pageCount > 1 && (
        <div className="pages mb-[100px]">
          {[...Array(pageCount).keys()].map((index) => (
            <button
              className={page === index ? "selected" : ""}
              onClick={() => setPage(index)}
              key={index}
            >
              {index + 1}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default CategoryPage;
